import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MaterialModule } from './material.module';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { GeneralTableComponent } from './components/general-table/general-table.component';
import { TitleHeadComponent } from './components/title-head/title-head.component'
import {InputComponent} from './components/input/input.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from './components/select/select.component';
import { DateComponent } from './components/date/date.component';
import { DocumentosSelectorComponent } from './components/documentos-selector/documentos-selector.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { OpcionesTablaComponent } from './components/opciones-tabla/opciones-tabla.component';
import { DocumentosDragDropComponent } from './components/documentos-drag-drop/documentos-drag-drop.component';
import { ngfModule } from "angular-file"
import { OnlyNumbersDirective } from './only-numbers.directive';
import { environment } from '../environments/environment';
import { VerDocumentosModalComponent } from './modales/ver-documentos-modal/ver-documentos-modal.component';

// import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
	declarations: [

		GeneralTableComponent,
		TitleHeadComponent,
		InputComponent,
		SelectComponent,
		DateComponent,
		DocumentosSelectorComponent,
		PdfViewerComponent,
		OpcionesTablaComponent,
		OnlyNumbersDirective,
    DocumentosDragDropComponent,
    VerDocumentosModalComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,

		LoggerModule.forRoot({
			//serverLoggingUrl: '/api/logs', //por definir ver que ruta usa el back para imprimir los logs
			level: !environment.production ? NgxLoggerLevel.LOG : NgxLoggerLevel.OFF,
			serverLogLevel: NgxLoggerLevel.ERROR,
			disableConsoleLogging: true
		}),
		ngfModule
		//ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }), // TIENE UN BUG QUE HAY QUE SOLUCIONAR
	],
	exports: [
		MaterialModule,
		LoggerModule,
		GeneralTableComponent,
		TitleHeadComponent,
		InputComponent,
		SelectComponent,
		DateComponent,
		DocumentosSelectorComponent,
		PdfViewerComponent,
		OpcionesTablaComponent,
		OnlyNumbersDirective,
    DocumentosDragDropComponent,
    VerDocumentosModalComponent
	],
	providers: [CurrencyPipe]

})
export class SharedModule { }
